import { useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'quartz-routing/react-router';
const useSearchParams = () => {
  const history = useHistory();
  const location = useLocation();
  const setSearchParams = useCallback(params => {
    const newSearchParams = new URLSearchParams(location.search);
    Object.entries(params).forEach(([key, value]) => {
      if (value === undefined || value === null || value === '') {
        newSearchParams.delete(key);
        return;
      }
      if (Array.isArray(value)) {
        newSearchParams.delete(key);
        value.forEach(v => newSearchParams.append(key, v));
      } else {
        newSearchParams.set(key, value);
      }
    });
    history.replace(Object.assign({}, location, {
      search: `?${newSearchParams}`
    }));
  }, [history, location]);
  const searchParams = useMemo(() => {
    const result = {};
    const params = new URLSearchParams(location.search);
    for (const key of params.keys()) {
      var _allValues$;
      const allValues = params.getAll(key);
      result[key] = allValues.length > 1 ? allValues : (_allValues$ = allValues[0]) !== null && _allValues$ !== void 0 ? _allValues$ : undefined;
    }
    return result;
  }, [location.search]);
  return [searchParams, setSearchParams];
};
export default useSearchParams;